export const ADD_DATA = 'ADD_DATA';
export const ADD_PROPERTY = 'ADD_PROPERTY';
export const CLEAR_DATA = 'CLEAR_DATA';

export const TAB_ACTION = 'TAB_ACTION';
